import { render, staticRenderFns } from "./CurrencySettings.vue?vue&type=template&id=1f193876"
import script from "./CurrencySettings.vue?vue&type=script&lang=js"
export * from "./CurrencySettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports